<div class="gradient-separator" *ngIf="goalPeriod.panoramaResults.length > 0"></div>
<div *ngFor="let item of goalPeriod.panoramaResults" class="result-item" [ngClass]="{'not-selected': isSelectionExists && !isSelected(item) }">
    <div class="result-name">
        {{ item.startDate | datePlain }} - {{ item.endDate | datePlain }}
        <mat-icon class="selected-item-icon" *ngIf="isSelected(item)">check</mat-icon>
    </div>
    <div class="result-actions">
        <div class="gauge-container">
            <ngx-gauge type="full"
                    [value]="getGaugeValue(item) | number: '1.0-0'" 
                    [size]="gaugeSize" 
                    label=""
                    [thick]="gaugeThick"
                    foregroundColor="#17A5E3"
                    append="%">
            </ngx-gauge>
        </div>
         <a mat-flat-button color="accent" [routerLink]="['/reports/panorama-aura', goalPeriod.employeeId, item.reviewPeriodId]" class="action-button">Riport</a>
         <button mat-flat-button color="primary" class="action-button" [disabled]="!allowEdit()" (click)="onSelect(item)">{{ 'GOAL_COMPETENCY_RESULT_SELECTOR.SELECT' | translate }}</button>
    </div>
</div>
